import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
// Add New holiday
export const add_holiday = async (values) => {
  let response = await axios.post(baseURL + "/api/holidays", values);
  return response.data;
}
// List of holidays
export const get_all_holidays = async () => {
  let response = await axios.get(baseURL + "/api/holidays");
  return response.data;
}
// Delete holiday
export const delete_holiday = async (id: number) => {
  let response = await axios.delete(baseURL + "/api/holidays/" + id);
  return response.data;
}
// Get Single holiday
export const get_single_holidays = async (id) => {
  let response = await axios.get(baseURL + "/api/holidays/" + id);
  return response.data;
}
// Edit holiday Type
export const update_holiday = async (id: number, data: object) => {
  const response = await axios.patch(baseURL + "/api/holidays/" + id, data);
  return response.data;
}
// Get Single holiday Logs by ID
export const get_single_holiday_log = async (id: number) => {
  let response = await axios.get(`${baseURL}/api/holiday-activity-log/${id}`);
  return response.data;
};
// Get All Department Logs
export const get_all_holidays_logs = async () => {
  let response = await axios.get(`${baseURL}/api/holiday-activity-logs`);
  return response.data;
};
//Filters on Holiday Type List
export const get_all_filters_item_holidays = async (per_page, page, holiday, employee) => {
  const params: any = {};
  if (per_page) params.per_page = per_page;
  if (page) params.page = page;
  if (employee) params.updated_by = employee;
  if (holiday) params.holiday_type_id = holiday;
  const response = await axios.get(`${baseURL}/api/get-holidays-list-by-filter`, {
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};
export const get_all_holidays_by_filters = async (filters: {
  from_date?: string;
  to_date?: string;
  title?: string;
  users?: number[]; // expecting an array of user IDs
  updated_by?: number;
} = {}) => {
  const baseURL = secureLocalStorage.getItem("baseURL");

  // create payload
  const payload: any = { ...filters };

  // remove empty or undefined fields
  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete payload[key];
    }
  });

  try {
    const response = await axios.post(
      `${baseURL}/api/get-holidays-list-by-filter`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching filtered holidays:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch holidays"
      );
    }
    throw error;
  }
};
